import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  view: "",
  prevPageView: "",
  pinSearchFromUrl: false
};

export const placesRightPanelView = createSlice({
  name: "placesRightPanelView",
  initialState,
  reducers: {
    setView: (state, action) => {
      state.view = action.payload;
    },
    setPrevPageView: (state, action) => {
      state.prevPageView = action.payload;
    },
    setPinSearchFromUrl: (state, action) => {
      state.pinSearchFromUrl = action.payload;
    }
  }
});

export const { setView, setPrevPageView, setPinSearchFromUrl } =
  placesRightPanelView.actions;

export default placesRightPanelView.reducer;
